<script setup>
import random from 'lodash-es/random';
import { GA } from '@/mixins/Ga';
import { useStore } from '@/store/Store.js';

defineProps({
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    type: { type: String, default: 'quoteBig' },
    color: { type: String, default: null },
    themeColor: { type: String, default: '' },
});

const store = useStore();

const grid = [];
const space = { x: 240, y: 150 };
const pos = { x: 0, y: -space.y };
let modulo = 7;

if (store.xs.value) {
    modulo = 4;
    space.x = 105;
    space.y = 70;
    pos.y = -space.y;
}

for (let i = 1; i <= 35; i++) {
    pos.x += space.x;
    if (i % modulo === 1) {
        pos.x = 0;
        pos.y += space.y;
    }
    grid.push({
        transform: store.xl.value || store.md.value ? `translate(${pos.x} ${pos.y})` : `translate(${pos.x} ${pos.y}) scale(.5)`,
        style: {
            'animation-delay': `${random(0.1, 1.1)}s`,
            'animation-duration': `${random(2.1, 4.1)}s`,
        },
    });
}

const ga = new GA({ category: 'endBody', action: 'clicInterne' });
</script>

<template>
    <div class="LightPanel relative flex h-120 justify-center overflow-hidden text-dark-blue md:h-175 md:overflow-visible">
        <div class="LightPanel__bg absolute inset-y-0 -left-10 -right-24 flex flex-wrap md:-left-22 md:-right-38">
            <svg
                class="fill-current"
                :viewBox="landscape || tablet ? '0 0 1680 700' : '0 0 460 480'"
                :class="{
                    'text-dark-red': color == 'red',
                    'text-dark-green': color == 'green',
                    'text-light-blue': color == 'blue',
                    'text-dark-yellow': color == 'yellow',
                    'text-light-red': type == 'pointOfSales',
                }"
            >
                <path
                    v-for="n in 35"
                    :key="'path' + n"
                    class="LightPanel__icon origin-top-left animate-pulse opacity-0"
                    :style="grid[n - 1].style"
                    :transform="grid[n - 1].transform"
                    d="M180,0A90,90,0,0,1,0,0Z"
                />
            </svg>
        </div>

        <div class="LightPanel__block relative flex flex-col items-center justify-center text-center">
            <div
                v-if="type == 'pointOfSales'"
                class="LightPanel__pin hidden h-16 w-8 md:block"
            >
                <Icon
                    class="fill-current"
                    type="pin"
                />
            </div>
            <h2
                class="h2 LightPanel__title px-6 md:my-12"
                :class="{
                    'w-full md:w-178': type == 'pointOfSales',
                    'w-full max-w-6xl': type == 'quoteBig',
                }"
            >
                {{ title }}
            </h2>
            <router-link
                v-if="type == 'pointOfSales' && subtitle !== ''"
                :to="{ name: 'location.' + lang }"
                v-on:click="ga.send({ label: 'decouvrirPointsVente' })"
            >
                <Btn
                    color="currentColor"
                    :text="subtitle"
                />
            </router-link>
            <h6
                v-else-if="typeof subtitle !== 'undefined' && subtitle !== ''"
                class="h6"
            >
                {{ subtitle }}
            </h6>
        </div>
    </div>
</template>
